// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getTemplateLimitAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`template_limit`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getTemplateLimitById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`template_limit/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getTemplateLimitLotteryTypeById = async ({ token, params } : any) => {
   // console.log(params)
   try {
      return await client
         .get(`template_limit_lottery_type/${params?.lottery_type_id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};



export const postCreateTemplateLimit = async ({ token, params } : any) => {
   try {
      return await client
         .post(`template_limit`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateTemplateLimit = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`template_limit/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteTemplateLimit = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`template_limit/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const postExportLimitnumberExcel = async ({ token, params } : any) => {
   try {
      return await client
         .post(`limitnumber_export_excel`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            responseType: 'blob', // ระบุว่า response ที่คาดหวังคือ blob
         })
         .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            // link.setAttribute('download', `receipt.xlsx`); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
            link.setAttribute('download', `นำข้อมูลเลขอั้นออกงวดเลขไอดีที่_${params.limitnumber_period_id}.xlsx`); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // คืนทรัพยากร URL

            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};